import { MvnCodeInitiate } from "../../lib/const";
import { MvnCodeFE } from "../const";

export const DOCS_CONTACT_LANG: {
  DOCS_CONTACT_NOUN: MvnCodeFE;
  DOCS_COMMON_COMPANY_NOUN: MvnCodeFE;
  DOCS_COMMON_TITLE_NOUN: MvnCodeFE;
  DOCS_CONTACT_ALL_NOUN: MvnCodeFE;
  DOCS_CONTACT_MY_NOUN: MvnCodeFE;
  DOCS_CONTACT_PUBLIC_NOUN: MvnCodeFE;
  DOCS_CONTACT_ADD_NOUN: MvnCodeFE;
  DOCS_CONTACT_ADD_SINGLE_NOUN: MvnCodeFE;
  DOCS_CONTACT_ADD_TEMPLATE_NOUN: MvnCodeFE;
  DOCS_CONTACT_NO_DATA_TITLE: MvnCodeFE;
  DOCS_CONTACT_NO_DATA_DESCRIPTION: MvnCodeFE;
  DOCS_CONTACT_GROUP_SEARCH_NO_DATA_DESCRIPTION: MvnCodeFE;
  DOCS_CONTACT_TOOLTIP_TITLE: MvnCodeFE;
  DOCS_CONTACT_TOOLTIP_DESCRIPTION: MvnCodeFE;
  DOCS_CONTACT_ADD_GROUP_TITLE: MvnCodeFE;
  DOCS_CONTACT_DELETE_GROUP_TITLE: MvnCodeFE;
  DOCS_CONTACT_DELETE_GROUP_DIALOG_DESC: MvnCodeFE;
  DOCS_CONTACT_ADD_TO_GROUP_NOUN: MvnCodeFE;
  DOCS_CONTACT_ADD_TO_GROUP_TOOLTIP_DESCRIPTION: MvnCodeFE;
  DOCS_CONTACT_ADD_CONTACT_DIALOG_TITLE: MvnCodeFE;
  DOCS_CONTACT_ADD_CONTACT_TEMPLATE_DIALOG_TITLE: MvnCodeFE;
  DOCS_CONTACT_ADD_CONTACT_TEMPLATE_UPLOAD_DESC: MvnCodeFE;
  DOCS_CONTACT_ADD_CONTACT_UPLOAD_BUTTON: MvnCodeFE;
  DOCS_CONTACT_DOWNLOAD_TEMPLATE_BUTTON: MvnCodeFE;
  DOCS_CONTACT_EDIT_CONTACT_DIALOG_TITLE: MvnCodeFE;
  DOCS_CONTACT_DELETE_CONTACT_DIALOG_TITLE: MvnCodeFE;
  DOCS_CONTACT_DELETE_CONTACT_DIALOG_DESC: MvnCodeFE;
  DOCS_CONTACT_DELETE_CONTACT_DIALOG_DELETE_FROM_LABEL: MvnCodeFE;
  DOCS_CONTACT_DELETE_CONTACT_DIALOG_ONLY_GROUP_SELECTION: MvnCodeFE;
  DOCC_CONTACT_DELETE_CONTACT_DIALOG_BOTH_GROUP_CONTACT_SELECTION: MvnCodeFE;
  DOCS_CONTACT_ADD_TO_GROUP_DIALOG_TITLE: MvnCodeFE;
  DOCS_CONTACT_ADD_TO_GROUP_CONTACT_DESC: MvnCodeFE;
  DOCS_CONTACT_ADD_TO_GROUP_CONTACT_DESC_AND_OTHERS: MvnCodeFE;
  DOCS_CONTACT_GROUP_NOUN: MvnCodeFE;
  DOCS_CONTACT_ADD_TO_GROUP_PLACEHOLDER: MvnCodeFE;
  DOCS_CONTACT_NO_GROUP_TITLE: MvnCodeFE;
  DOCS_CONTACT_NO_GROUP_TITLE_WITH_PLUS: MvnCodeFE;
  DOCS_CONTACT_EDIT_GROUP_PLACEHOLDER: MvnCodeFE;
  DOCS_CONTACT_EDIT_GROUP_PLACEHOLDER_WITH_COUNT: MvnCodeFE;
  DOCS_CONTACT_SCOPE_NOUN: MvnCodeFE;
  DOCS_CONTACT_ADDITIONAL_INFO_NOUN: MvnCodeFE;
  DOCS_CONTACT_NAME_NOUN: MvnCodeFE;
  DOCS_CONTACT_EMAIL_NOUN: MvnCodeFE;
  DOCS_CONTACT_PHONE_NOUN: MvnCodeFE;
  DOCS_CONTACT_DESCRIPTION_NOUN: MvnCodeFE;
  DOCS_CONTACT_PLACEHOLDER_NAME: MvnCodeFE;
  DOCS_CONTACT_PLACEHOLDER_EMAIL: MvnCodeFE;
  DOCS_CONTACT_PLACEHOLDER_PHONE: MvnCodeFE;
  DOCS_CONTACT_PLACEHOLDER_COMPANY: MvnCodeFE;
  DOCS_CONTACT_PLACEHOLDER_TITLE: MvnCodeFE;
  DOCS_CONTACT_PLACEHOLDER_GROUP: MvnCodeFE;
  DOCS_CONTACT_PLACEHOLDER_DESCRIPTION: MvnCodeFE;
  DOCS_CONTACT_CREATE_NOUN: MvnCodeFE;
  DOCS_CONTACT_SAVE_LOCATION_NOUN: MvnCodeFE;
  DOCS_CONTACT_LATEST_UPDATE_LABEL: MvnCodeFE;
  DOCS_CONTACT_LATEST_UPDATE_DESC: MvnCodeFE;
  DOCS_CONTACT_GROUP_NAME_UPDATE_SUCC: MvnCodeFE;
  DOCS_CONTACT_GROUP_NAME_UPDATE_FAIL: MvnCodeFE;
  DOCS_CONTACT_GROUP_DELETE_SUCC: MvnCodeFE;
  DOCS_CONTACT_GROUP_DELETE_FAIL: MvnCodeFE;
  DOCS_CONTACT_GROUP_NAME_TOO_SHORT: MvnCodeFE;
  DOCS_CONTACT_GROUP_NAME_TOO_LONG: MvnCodeFE;
  DOCS_CONTACT_GOUP_DUPLICATE_NAME_WARN: MvnCodeFE;
  DOCS_CONTACT_ADD_TO_GROUP_SUCC: MvnCodeFE;
  DOCS_CONTACT_ADD_TO_GOUP_FAIL: MvnCodeFE;
  DOCS_CONTACT_ADD_CONTACT_SUCC: MvnCodeFE;
  DOCS_CONTACT_ADD_CONTACT_TEMPLATE_SUCC: MvnCodeFE;
  DOCS_CONTACT_ADD_CONTACT_FAIL: MvnCodeFE;
  DOCS_CONTACT_EDIT_CONTACT_SUCC: MvnCodeFE;
  DOCS_CONTACT_DEIT_CONTACT_FAIL: MvnCodeFE;
  DOCS_CONTACT_DOWNLOAD_TEMPLATE_SUCC: MvnCodeFE;
  DOCS_CONTSCT_DOWNLOAD_TEMPLATE_FAIL: MvnCodeFE;
  DOCS_CONTACT_DELETE_CONTACT_FROM_GROUP_DIALOG_SUCCESS: MvnCodeFE;
  DOCS_CONTACT_DELETE_CONTACT_FROM_GROUP_DIALOG_FAIL: MvnCodeFE;
  DOCS_CONTACT_DELETE_CONTACT_DIALOG_SUCCESS: MvnCodeFE;
  DOCS_CONTACT_DELETE_CONTACT_DIALOG_FAIL: MvnCodeFE;
  DOCS_CONTACT_PUBLIC_CONTACT_SAVE_LOCATION_UNAVAILABLE: MvnCodeFE;
  DOCS_CONTACT_DIALOG_ADD_CONTACT_DESCRIPTION: MvnCodeFE;
  DOCS_CONTACT_DIALOG_SELECTED_SIGNER_CONTACT_COUNT_EXCEED: MvnCodeFE;
  DOCS_CONTACT_DIALOG_SELECTED_REFERRER_CONTACT_COUNT_EXCEED: MvnCodeFE;
  DOCS_CONTACT_DIALOG_ADD_SIGNERS_SUCCESS: MvnCodeFE;
  DOCS_CONTACT_DIALOG_ADD_REFERRERS_SUCCESS: MvnCodeFE;
  DOCS_CONTACT_DIALOG_ADD_SIGNERS_AND_REFERRERS_SUCCESS: MvnCodeFE;
  DOCS_CONTACT_DIALOG_ADD_SIGNERS_MAX_LENGTH_EXCEED: MvnCodeFE;
  DOCS_CONTACT_DIALOG_ADD_REFERRERS_MAX_LENGTH_EXCEED: MvnCodeFE;
  DOCS_CONTACT_DELETE_PUBLIC_CONTACT_TOOLTIP_DESCRIPTION: MvnCodeFE;
  DOCS_CONTACT_EMAIL_DUPLICATED: MvnCodeFE;
} = {
  DOCS_CONTACT_SAVE_LOCATION_NOUN: {
    ko: "저장 위치",
    en: "Save Location",
  },
  DOCS_CONTACT_NOUN: {
    ko: "주소록",
    en: "Contacts",
  },
  DOCS_COMMON_COMPANY_NOUN: {
    ko: "소속/회사",
    en: "Company",
  },
  DOCS_COMMON_TITLE_NOUN: {
    ko: "직위/직책",
    en: "Title",
  },
  DOCS_CONTACT_ALL_NOUN: {
    ko: "전체 연락처",
    en: "All Contacts",
  },
  DOCS_CONTACT_MY_NOUN: {
    ko: "내 주소록",
    en: "My Contacts",
  },
  DOCS_CONTACT_PUBLIC_NOUN: {
    ko: "공용 주소록",
    en: "Public Contacts",
  },
  DOCS_CONTACT_ADD_NOUN: {
    ko: "연락처 추가",
    en: "Add Contact",
  },
  DOCS_CONTACT_ADD_SINGLE_NOUN: {
    ko: "개별 추가",
    en: "Add Single Contact",
  },
  DOCS_CONTACT_ADD_TEMPLATE_NOUN: {
    ko: "템플릿으로 추가",
    en: "Add with template",
  },
  DOCS_CONTACT_NO_DATA_TITLE: {
    ko: "추가된 연락처가 없습니다.",
    en: "There are no added contacts",
  },
  DOCS_CONTACT_NO_DATA_DESCRIPTION: {
    ko: "주소록을 사용하려면 연락처를 추가해주세요.",
    en: "Please add contacts to use",
  },
  DOCS_CONTACT_GROUP_SEARCH_NO_DATA_DESCRIPTION: {
    ko: "연락처를 추가하거나 주소록 리스트에서 그룹을 지정 할 수 있습니다.",
    en: "You can add contacts or assign groups from your contact list.",
  },
  DOCS_CONTACT_TOOLTIP_TITLE: {
    ko: "주소록 기능이 추가되었습니다.",
    en: "New Contacts Feature.",
  },
  DOCS_CONTACT_TOOLTIP_DESCRIPTION: {
    ko: "자주 사용하는 연락처를 저장하고\n서명 요청시 바로 불러올 수 있습니다.",
    en: "Save your frequently used contacts\nand use them when requesting E-Sign.",
  },
  DOCS_CONTACT_ADD_GROUP_TITLE: {
    ko: "그룹 추가",
    en: "Add Group",
  },
  DOCS_CONTACT_DELETE_GROUP_TITLE: {
    ko: "그룹 삭제",
    en: "Delete Group",
  },
  DOCS_CONTACT_DELETE_GROUP_DIALOG_DESC: {
    ko: "그룹을 삭제하시겠습니까? 그룹을 삭제해도 연락처는 유지됩니다.",
    en: "Do you want to delete the group?\nThe contacts will remain in the list.",
  },
  DOCS_CONTACT_ADD_TO_GROUP_NOUN: {
    ko: "그룹 지정",
    en: "Add to Group",
  },
  DOCS_CONTACT_ADD_TO_GROUP_TOOLTIP_DESCRIPTION: {
    ko: "동일 주소록 내 연락처만 그룹으로 지정할 수 있습니다.",
    en: "Group can only include contacts from the same contact list.",
  },
  DOCS_CONTACT_ADD_CONTACT_DIALOG_TITLE: {
    ko: "연락처 개별 추가",
    en: "Add Single Contact",
  },
  DOCS_CONTACT_ADD_CONTACT_TEMPLATE_DIALOG_TITLE: {
    ko: "연락처 템플릿으로 추가",
    en: "Add with Template",
  },
  DOCS_CONTACT_ADD_CONTACT_TEMPLATE_UPLOAD_DESC: {
    ko: "템플릿을 업로드해주세요.",
    en: "Please upload template",
  },
  DOCS_CONTACT_ADD_CONTACT_UPLOAD_BUTTON: {
    ko: "업로드",
    en: "Upload",
  },
  DOCS_CONTACT_DOWNLOAD_TEMPLATE_BUTTON: {
    ko: "템플릿 다운로드",
    en: "Download Template",
  },
  DOCS_CONTACT_EDIT_CONTACT_DIALOG_TITLE: {
    ko: "연락처 수정",
    en: "Edit Contact",
  },
  DOCS_CONTACT_DELETE_CONTACT_DIALOG_TITLE: {
    ko: "연락처 삭제",
    en: "Delete Contact",
  },
  DOCS_CONTACT_DELETE_CONTACT_DIALOG_DESC: {
    ko: "삭제된 연락처는 복구할 수 없습니다. 정말 삭제하시겠습니까?",
    en: "Deleted contacts cannot be restored. Are you sure you want to delete them?",
  },
  DOCS_CONTACT_DELETE_CONTACT_DIALOG_DELETE_FROM_LABEL: {
    ko: "삭제할 위치",
    en: "Delete from",
  },
  DOCS_CONTACT_DELETE_CONTACT_DIALOG_ONLY_GROUP_SELECTION: {
    ko: "그룹에서 삭제",
    en: "Only from this group",
  },
  DOCC_CONTACT_DELETE_CONTACT_DIALOG_BOTH_GROUP_CONTACT_SELECTION: {
    ko: "그룹과 주소록에서 모두 삭제",
    en: "Both this group and contacts list",
  },
  DOCS_CONTACT_ADD_TO_GROUP_DIALOG_TITLE: {
    ko: "그룹 지정",
    en: "Add to Group",
  },
  DOCS_CONTACT_ADD_TO_GROUP_CONTACT_DESC: {
    ko: "선택한 연락처 :",
    en: "Selected contacts :",
  },
  DOCS_CONTACT_ADD_TO_GROUP_CONTACT_DESC_AND_OTHERS: {
    ko: "{name} 외 {count}명",
    en: "{name} and {count} others",
  },
  DOCS_CONTACT_GROUP_NOUN: {
    ko: "그룹",
    en: "Group",
  },
  DOCS_CONTACT_ADD_TO_GROUP_PLACEHOLDER: {
    ko: "그룹 선택",
    en: "Select group",
  },
  DOCS_CONTACT_NO_GROUP_TITLE: {
    ko: "추가된 그룹없음.",
    en: "No added group.",
  },
  DOCS_CONTACT_NO_GROUP_TITLE_WITH_PLUS: {
    ko: "추가된 그룹없음. ‘+’로 그룹 추가",
    en: "No added group. Add group with '+'.",
  },
  DOCS_CONTACT_EDIT_GROUP_PLACEHOLDER: {
    ko: "그룹명 입력",
    en: "Enter group name",
  },
  DOCS_CONTACT_EDIT_GROUP_PLACEHOLDER_WITH_COUNT: {
    ko: "새 그룹 {count}",
    en: "New group {count}",
  },
  DOCS_CONTACT_SCOPE_NOUN: {
    ko: "저장 위치",
    en: "Save Location",
  },
  DOCS_CONTACT_ADDITIONAL_INFO_NOUN: {
    ko: "부가정보",
    en: "Additional Info",
  },
  DOCS_CONTACT_NAME_NOUN: {
    ko: "이름",
    en: "Name",
  },
  DOCS_CONTACT_EMAIL_NOUN: {
    ko: "이메일",
    en: "Email",
  },
  DOCS_CONTACT_PHONE_NOUN: {
    ko: "휴대폰",
    en: "Phone",
  },
  DOCS_CONTACT_DESCRIPTION_NOUN: {
    ko: "설명",
    en: "Description",
  },
  DOCS_CONTACT_PLACEHOLDER_NAME: {
    ko: "이름 입력",
    en: "Enter name",
  },
  DOCS_CONTACT_PLACEHOLDER_EMAIL: {
    ko: "이메일 입력",
    en: "Enter email",
  },
  DOCS_CONTACT_PLACEHOLDER_PHONE: {
    ko: "휴대폰 번호 입력",
    en: "Enter phone",
  },
  DOCS_CONTACT_PLACEHOLDER_COMPANY: {
    ko: "소속/회사 입력",
    en: "Enter company",
  },
  DOCS_CONTACT_PLACEHOLDER_TITLE: {
    ko: "직위/직책 입력",
    en: "Enter title",
  },
  DOCS_CONTACT_PLACEHOLDER_GROUP: {
    ko: "그룹 선택",
    en: "Select group",
  },
  DOCS_CONTACT_PLACEHOLDER_DESCRIPTION: {
    ko: "최대 100자",
    en: "Max 100 characters",
  },
  DOCS_CONTACT_CREATE_NOUN: {
    ko: "새 그룹 추가",
    en: "Add New Group",
  },
  DOCS_CONTACT_LATEST_UPDATE_LABEL: {
    ko: "최근 업데이트",
    en: "Latest Update",
  },
  DOCS_CONTACT_LATEST_UPDATE_DESC: {
    ko: "님이 수정하였습니다.",
    en: "editied.",
  },
  DOCS_CONTACT_ADD_CONTACT_SUCC: {
    ko: "{scope}에 연락처가 추가되었습니다.",
    en: "Contact has been added to {scope}.",
  },
  DOCS_CONTACT_ADD_CONTACT_TEMPLATE_SUCC: {
    ko: "템플릿으로 연락처가 추가되었습니다.",
    en: "Contacts have been added with template.",
  },
  DOCS_CONTACT_ADD_CONTACT_FAIL: {
    ko: "연락처 추가에 실패하였습니다. ({message})",
    en: "Failed to add a contact. ({message})",
  },
  DOCS_CONTACT_EDIT_CONTACT_SUCC: {
    ko: "저장되었습니다.",
    en: "Changes have been saved.",
  },
  DOCS_CONTACT_DEIT_CONTACT_FAIL: {
    ko: "저장에 실패하였습니다. ({message})",
    en: "Failed to save changes. ({message})",
  },
  DOCS_CONTACT_DOWNLOAD_TEMPLATE_SUCC: {
    ko: "템플릿을 다운로드하였습니다.",
    en: "Template Downloaded.",
  },
  DOCS_CONTSCT_DOWNLOAD_TEMPLATE_FAIL: {
    ko: "템플릿 다운로드에 실패하였습니다. ({message})",
    en: "Failed to download the template ({message})",
  },
  DOCS_CONTACT_DELETE_CONTACT_FROM_GROUP_DIALOG_SUCCESS: {
    ko: "연락처를 그룹에서 삭제하였습니다.",
    en: "Contact has been deleted from the group.",
  },
  DOCS_CONTACT_DELETE_CONTACT_FROM_GROUP_DIALOG_FAIL: {
    ko: "연락처를 그룹에서 삭제하는데 실패하였습니다. ({message})",
    en: "Failed to delete contact from the group. ({message})",
  },
  DOCS_CONTACT_DELETE_CONTACT_DIALOG_SUCCESS: {
    ko: "연락처를 삭제하였습니다.",
    en: "Contact has been deleted.",
  },
  DOCS_CONTACT_DELETE_CONTACT_DIALOG_FAIL: {
    ko: "연락처를 삭제하는데 실패하였습니다. ({message})",
    en: "Failed to delete contact. ({message})",
  },
  DOCS_CONTACT_GROUP_DELETE_SUCC: {
    ko: "그룹이 삭제되었습니다.",
    en: "The group has been deleted.",
  },
  DOCS_CONTACT_GROUP_DELETE_FAIL: {
    ko: "그룹 제거에 실패하였습니다. ({message})",
    en: "Failed to delete group ({message})",
  },
  DOCS_CONTACT_GROUP_NAME_UPDATE_SUCC: {
    ko: "그룹명을 변경하였습니다.",
    en: "Group name has beed updated.",
  },
  DOCS_CONTACT_GROUP_NAME_UPDATE_FAIL: {
    ko: "그룹명 변경에 실패했습니다. ({message})",
    en: "Failed to change name. ({message})",
  },
  DOCS_CONTACT_GROUP_NAME_TOO_LONG: {
    ko: "그룹명은 최대 {limit}자까지 입력 가능합니다.",
    en: "You can enter up to {limit}characters for name.",
  },
  DOCS_CONTACT_GROUP_NAME_TOO_SHORT: {
    ko: "그룹명을 입력해주세요.",
    en: "Please enter the name.",
  },
  DOCS_CONTACT_GOUP_DUPLICATE_NAME_WARN: {
    ko: "그룹명이 이미 존재합니다.",
    en: "The Group name already exists.",
  },
  DOCS_CONTACT_ADD_TO_GROUP_SUCC: {
    ko: "그룹이 지정되었습니다.",
    en: "Contacts have been added to the group.",
  },
  DOCS_CONTACT_ADD_TO_GOUP_FAIL: {
    ko: "그룹 지정에 실패하였습니다. ({message})",
    en: "Failed to add to the group. ({message})",
  },
  DOCS_CONTACT_PUBLIC_CONTACT_SAVE_LOCATION_UNAVAILABLE: {
    ko: "공용 주소록의 연락처는 저장 위치를 수정할 수 없습니다.",
    en: "Contacts in the public contacts cannot be moved.",
  },
  DOCS_CONTACT_DIALOG_ADD_CONTACT_DESCRIPTION: {
    ko: "추가할 연락처를 선택후 > 버튼을 눌러주세요.",
    en: "Please select contacts and press > button.",
  },
  DOCS_CONTACT_DIALOG_SELECTED_SIGNER_CONTACT_COUNT_EXCEED: {
    ko: "선택한 인원이 최대 서명자 수({max}명)을 초과했습니다.",
    en: "The selected contacts exceed the maximum number of signees ({max}).",
  },
  DOCS_CONTACT_DIALOG_SELECTED_REFERRER_CONTACT_COUNT_EXCEED: {
    ko: "선택한 인원이 최대 참조자 수({max}명)을 초과했습니다.",
    en: "The selected contacts exceed the maximum number of CC recipients ({max}).",
  },
  DOCS_CONTACT_DIALOG_ADD_SIGNERS_SUCCESS: {
    ko: "서명자 {signees}명이 추가되었습니다.",
    en: "{signees} Signees have been added.",
  },
  DOCS_CONTACT_DIALOG_ADD_REFERRERS_SUCCESS: {
    ko: "참조자 {cc}명이 추가되었습니다.",
    en: "{cc} CC recipients have been added.",
  },
  DOCS_CONTACT_DIALOG_ADD_SIGNERS_AND_REFERRERS_SUCCESS: {
    ko: "서명자 {signees}명과 참조자 {cc}명이 추가되었습니다.",
    en: "{signees} Signees and {cc} CC recipients have been added.",
  },
  DOCS_CONTACT_DIALOG_ADD_SIGNERS_MAX_LENGTH_EXCEED: {
    ko: "더이상 서명자를 추가할 수 없습니다.",
    en: "No more signees can be added.",
  },
  DOCS_CONTACT_DIALOG_ADD_REFERRERS_MAX_LENGTH_EXCEED: {
    ko: "더이상 참조자를 추가할 수 없습니다.",
    en: "No more CC recipients can be added.",
  },
  DOCS_CONTACT_DELETE_PUBLIC_CONTACT_TOOLTIP_DESCRIPTION: {
    ko: "공용 주소록의 연락처를 삭제할 권한이 없습니다.",
    en: "No permission to delete contacts from the public contacts.",
  },
  DOCS_CONTACT_EMAIL_DUPLICATED: {
    ko: "{scope}에 이미 존재하는 이메일입니다.",
    en: "This email already exists in {scope}.",
  },
};

MvnCodeInitiate(DOCS_CONTACT_LANG);
